export default {
    template: ['VFAIRORGANIZATION_TEMPLATE', data => ({})],
    '/organizations': {
        authorize: true,
        template: [
            'VFAIRORGANIZATION_TEMPLATE',
            data => ({
                vfairId: data.vfairId,
                id: data.vfairId + '_' + data.organizationId,
                organizationId: data.organizationId,
                backgroundImage: data.backgroundImage,
                email: data.email,
                facebook: data.facebook,
                instagram: data.instagram,
                linkedIn: data.linkedIn,
                logo: data.logo,
                organizationId: data.organizationId,
                phone: data.phone,
                presentation: data.presentation,
                status: data.status,
                tagline: data.tagline,
                title: data.title,
                twitter: data.twitter,
                url: data.url,
                vfairId: data.vfairId,
                vimeo: data.vimeo,
                weChat: data.weChat,
                youTube: data.youTube,
            }),
        ],
        GET: {},
    },
};
